export const formatCurrency = (amount: number, currency: string) => {
	switch (currency) {
		case "nuARS":
		case "ARS":
			return amount.toFixed(2)
		default:
			return amount
	}
}

export const formatDate = (date: Date) => {
	return date.toLocaleDateString("es-AR", {
		day: "2-digit",
		month: "2-digit",
		year: "2-digit",
	})
}
